<dialog class="ox-modal" aria-modal="true" open>
  <form [formGroup]="form" (ngSubmit)="confirm()">
    <button type="button" class="ox-modal__close" aria-label="Close the modal" (click)="reject()">
      <span class="ox-icon ox-icon--close ox-icon--small"></span>
    </button>
    <div class="ox-modal__body">
      <h3 class="ox-modal__title">
        @if (type === confirmationType.START_SHIFT) {
          <span>{{ 'SHIFT.START_SHIFT' | translate }}</span>
        }
        @if (type === confirmationType.END_SHIFT) {
          <span>{{ 'SHIFT.END_SHIFT' | translate }}</span>
        }
      </h3>
      <p>
        @if (type === confirmationType.START_SHIFT) {
          <span
          >{{ 'SHIFT.INFO_BADGE_TIME_REGISTRATION' | translate }}</span>
        }
        @if (type === confirmationType.END_SHIFT) {
          <span
          >{{ 'SHIFT.INFO_BADGE_TIME_REGISTRATION_NIGHT_STAY' | translate }}</span>
        }
      </p>
      <div class="ox-form__group mt-4 mb-4" [class.ox-is-invalid]="isErrorShown">
        <label for="km-state" class="ox-form__label">
          @if (type === confirmationType.START_SHIFT) {
            <span
            >{{ ('COMMON.START' | translate | titlecase) }}</span>
          }
          @if (type === confirmationType.END_SHIFT) {
            <span
            >{{ ('COMMON.END' | translate | titlecase) }}</span>
          }
          <span> {{ 'SHIFT.KM_STATE' | translate }}</span>
        </label>
        <input type="number" id="km-state" class="ox-form__field" formControlName="kmState" inputmode="numeric"
          inputAutoFocus/>
      </div>
      @if (isErrorShown) {
        <div class="ox-is-invalid mt-4 mb-4" [@entryHeight]>
          <p class="ox-form__feedback txt-cap">
            @if (type === confirmationType.START_SHIFT) {
              <span
              >{{ 'SHIFT.INVALID_NONZERO_NUMBER' | translate }}</span>
            }
            @if (type === confirmationType.END_SHIFT) {
              <span>{{ 'SHIFT.END_KM_ERROR' | translate }}</span>
            }
            <span class="ox-icon ox-icon--error ml-2"></span>
          </p>
        </div>
      }
      @if (type === confirmationType.END_SHIFT) {
        <div class="ox-form__group flex-spread">
          <label for="night-stay" class="ox-form__label">{{ 'SHIFT.NIGHT_STAY' | translate | titlecase }}</label>
          <input type="checkbox"
            id="night-stay"
            formControlName="nightStay"
            class="ox-form__pillswitch"/>
        </div>
      }
    </div>
    <div class="ox-modal__footer">
      <div class="ox-button-group ox-button-group--right">
        <button type="submit" class="ox-button ox-button--primary" [disabled]="form.invalid" data-testid="dialog-shift-confirm">
          @if (type === confirmationType.START_SHIFT) {
            <span
            >{{ 'COMMON.START' | translate | titlecase }}</span>
          }
          @if (type === confirmationType.END_SHIFT) {
            <span
            >{{ 'COMMON.FINISH' | translate | titlecase }}</span>
          }
        </button>
        <button type="button" class="ox-button ox-button--secondary"
        (click)="reject()">{{ 'COMMON.CANCEL' | translate | titlecase }}</button>
      </div>
    </div>
  </form>
</dialog>
